<template>
  <v-layout row fill-height class="home">
    <v-layout column>
      <v-flex>
        <v-tabs v-if="profile && profile.organization">
          <v-tab v-for="tab in tabs[profile.organization.role]" :key="tab.key " :to="`/${tab.key}`">{{tab.description}}</v-tab>
        </v-tabs>
        <keep-alive>
          <router-view name="tab"></router-view>
        </keep-alive>
      </v-flex>
    </v-layout>
    <router-view name="sidebar"></router-view>
  </v-layout>
</template>

<script>

import { mapGetters } from 'vuex'
import { tabs } from '@/utils/permissions'

export default {
  computed: mapGetters({
    profile: 'profile'
  }),
  components: {
  },
  data () {
    return {
      tabs
    }
  }
}
</script>
